"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _reactRouter = require("react-router");

var _EULA = require("./EULA");

var _EULA2 = _interopRequireDefault(_EULA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var label = (0, _glamor.css)({
  display: "block",
  color: "#6F6F6F",
  marginBottom: "0.5em",
  textTransform: "uppercase"
});

var eulaText = (0, _glamor.css)({
  width: "100%",
  height: 462,

  border: "none",
  padding: "0.75em",
  marginBottom: "1em",

  color: "rgba(255, 255, 255, 0.5)",

  backgroundColor: "#171717"
});

var checkboxContainer = (0, _glamor.css)({
  display: "flex",
  alignItems: "end"
});
var anchor = (0, _glamor.css)({
  textDecoration: "none",
  marginLeft: "3px",
  color: "#2b98f0",
  transition: "box-shadow 0.2s, color 0.2s ease-in-out"
});

function EducationSubscriptionEULA(props) {
  var eulaAccepted = props.eulaAccepted,
      onCheckboxChange = props.onCheckboxChange;


  return _react2.default.createElement(
    "section",
    null,
    _react2.default.createElement(
      "label",
      null,
      _react2.default.createElement(
        "span",
        { className: label },
        "Free Non-Commercial License for Schools"
      ),
      _react2.default.createElement(
        "textarea",
        { className: eulaText, readOnly: true },
        _EULA2.default
      ),
      _react2.default.createElement(
        "div",
        { className: checkboxContainer },
        _react2.default.createElement(_Checkbox2.default, {
          label: "I agree to the ",
          checked: eulaAccepted,
          onChange: onCheckboxChange
        }),
        " ",
        _react2.default.createElement(
          _reactRouter.Link,
          {
            className: anchor,
            to: "/terms",
            target: "_blank",
            rel: "noopener noreferrer"
          },
          "Content License Agreement."
        ),
        " "
      )
    )
  );
}

exports.default = EducationSubscriptionEULA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EducationSubscriptionPopup/EducationSubscriptionEULA.jsx
// module id = 2842
// module chunks = 0